
export const RTC_ACTION = "RTC";

export const rtcAction = date => ({
	type: RTC_ACTION,
	date: date		/* String */
});

export const rtcReducer = (state = new Date().toString(), action) => {
	switch (action.type) {
	case RTC_ACTION:
		return action.date;
	default:
		return state;
	}
};
